import { Icon } from "../icons.js";
import { cn } from "../utils/cn.js";

export interface StreakPillProps {
  days: number;
  className?: string;
  /** Surface variant. "paper" sits on cream; "ink" on dark teal-ink. */
  variant?: "paper" | "ink";
}

/**
 * StreakPill — small badge showing the user's current reset streak.
 *
 * Mustard flame icon + number + "days" — sits in the topbar and in
 * the home greeting per the brand reference.
 */
export const StreakPill = ({ days, className, variant = "paper" }: StreakPillProps) => (
  <div
    className={cn(
      "inline-flex items-center gap-1.5 rounded-pill border px-3 py-1.5",
      variant === "paper"
        ? "border-line bg-paper text-ink"
        : "border-cream/20 bg-ink text-cream",
      className,
    )}
  >
    <Icon name="flame" size={16} className="text-mustard" />
    <span className="text-small font-bold">{days}</span>
    <span className="text-meta text-muted">days</span>
  </div>
);
